import { baseState } from '@/states/store'
import { getCookie } from './cookie'
const { UMI_ENV } = process.env

type OemSource = 'saas' | 'waimao'

export const isOEM = () => {
  return !!baseState.userInfo.oemFlag
}

export const redirectToOemSaas = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const bosId = searchParams.get('bosId') || getCookie('saasBosId')
  const key = searchParams.get('key') || getCookie('saasKey')

  if (!bosId || !key) {
    console.warn('SaaS OEM redirect cancelled: bosId or key is missing')
    return
  }

  //window.location.origin
  window.location.href = (UMI_ENV !== 'online'?'https://master.saas.weimobqa.com':'https://master.weimob.com') + `/bos/products/aigpt/${bosId}/${key}/aiwriting/workspace?type=0`
}

export const redirectToOemWaiMao = () => {
    window.location.href = UMI_ENV !== 'online'?'https://admin.shangyuanlabs.com':'https://admin.weimobtrade.com'
}

const resolveOemSource = (): OemSource | undefined => {
  const searchParams = new URLSearchParams(window.location.search)
  const queryOemSource = searchParams.get('oemSource')

  if (queryOemSource === 'waimao') {
    return 'waimao'
  }

  if (searchParams.get('bosId') && searchParams.get('key')) {
    return 'saas'
  }

  const { userId, oemFlag, loginSource } = baseState.userInfo

  if (loginSource === 'waimao') {
    return 'waimao'
  }

  if (userId && oemFlag === 1 && !loginSource) {
    return 'saas'
  }

  if (getCookie('oemSource') === 'waimao') {
    return 'waimao'
  }

  if (getCookie('saasBosId') && getCookie('saasKey')) {
    return 'saas'
  }
}

export const redirectToOem = () => {
  const oemSource = resolveOemSource()

  if (oemSource === 'saas') {
    return redirectToOemSaas()
  }

  if (oemSource === 'waimao') {
    return redirectToOemWaiMao()
  }

  console.warn('OEM redirect cancelled: source is not ready')
}
